import { get } from './helpers'
import { QuestionPreferenceResponse } from './types'

export const getPreferenceAnswers = async (): Promise<QuestionPreferenceResponse> => {
  const response = await get<QuestionPreferenceResponse>(`/preferences/answers`)

  return response
}
